import React, { useState } from "react";
import "../ContactInfo/ContactInfo.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

import Counter1 from "../../Img/counter-1.png";
import Counter2 from "../../Img/counter-2.png";
import Counter3 from "../../Img/counter-3.png";

import ContactFormWidget from './contact-form-widget';

const ContactInfo = () => {
  
  return (
    <div class="section harsafe-contact-section harsafe-contact-section-02 section-padding">
      <div class="container">
        {/* <!-- Contact Wrap Start --> */}
        <div class="contact-wrap contact-wcstm">
          <div class="row">
            <div class="col-xxl-5 col-lg-6">
              {/* <!-- Contact Info Start --> */}
              <div class="contact-info">
                <div class="section-title">
                  <h2 class="title">
                    To Make Requests For Further Information, Contact Us
                  </h2>
                </div>
                <ul>
                  <li>
                    {/* <!-- Contact Info Item Start --> */}
                    <div class="contact-info-item d-flex align-items-center">
                      <div class="contact-info-icon">
                        <FaPhoneAlt />
                      </div>
                      <div class="contact-info-text">
                        <h4 class="title">Contact Number</h4>
                        <p>+91 80037 73959</p>
                      </div>
                    </div>
                    {/* <!-- Contact Info Item End --> */}
                  </li>
                  <li>
                    {/* <!-- Contact Info Item Start --> */}
                    <div class="contact-info-item d-flex align-items-center">
                      <div class="contact-info-icon">
                        <FaEnvelope />
                      </div>
                      <div class="contact-info-text">
                        <h4 class="title">Our Mail</h4>
                        <p>info@harsafe.com</p>
                      </div>
                    </div>
                    {/* <!-- Contact Info Item End --> */}
                  </li>
                  <li>
                    {/* <!-- Contact Info Item Start --> */}
                    <div class="contact-info-item d-flex align-items-center">
                      <div class="contact-info-icon">
                        <FaMapMarkerAlt />
                      </div>
                      <div class="contact-info-text">
                        <h4 class="title">Our Location</h4>
                        <p>
                          Ward No.8, Srimadhopur Bazar, Srimadhopur, Sikar,
                          Rajasthan, India, 332715
                        </p>
                      </div>
                    </div>
                    {/* <!-- Contact Info Item End --> */}
                  </li>
                </ul>
              </div>
              {/* <!-- Contact Info End --> */}
            </div>
            <div class="col-xxl-7 col-lg-6">
              {/* <!-- Contact Form Start --> */}
              <div class="contact-form">
                <div class="contact-form-wrap">
                  <div class="heading-wrap text-center">
                    <span class="sub-title">Leave us massage</span>
                    <h3 class="title">How May We Help You!</h3>
                  </div>
                  <ContactFormWidget />
                </div>
              </div>
              {/* <!-- Contact Form End --> */}
            </div>
          </div>
        </div>
        {/* <!-- Contact Wrap End --> */}
      </div>
    </div>
  );
};

export default ContactInfo;
